// components/document-settings/RenderingTab.jsx
// Configurazione regole rendering PDF

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Save, Settings2 } from 'lucide-react';

export const RenderingTab = ({
  renderingRules,
  setRenderingRules,
  loading,
  onSaveRenderingRules
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Regole di Rendering</h3>
          <p className="text-sm text-gray-500">Configura la generazione dei PDF</p>
        </div>
        <Button onClick={onSaveRenderingRules} disabled={loading} className="bg-[#FF7819] hover:bg-[#E56A10]">
          <Save className="w-4 h-4 mr-1.5" />
          Salva
        </Button>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Formato Pagina</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Dimensione Pagina</Label>
              <Select 
                value={renderingRules.page_size}
                onValueChange={v => setRenderingRules({...renderingRules, page_size: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="A4">A4 (210 x 297 mm)</SelectItem>
                  <SelectItem value="Letter">Letter (8.5 x 11 in)</SelectItem>
                  <SelectItem value="Legal">Legal (8.5 x 14 in)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Margine Superiore (mm)</Label>
                <Input
                  type="number"
                  value={renderingRules.page_margin_top}
                  onChange={e => setRenderingRules({...renderingRules, page_margin_top: parseInt(e.target.value) || 0})}
                />
              </div>
              <div>
                <Label>Margine Inferiore (mm)</Label>
                <Input
                  type="number"
                  value={renderingRules.page_margin_bottom}
                  onChange={e => setRenderingRules({...renderingRules, page_margin_bottom: parseInt(e.target.value) || 0})}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Margine Sinistro (mm)</Label>
                <Input
                  type="number"
                  value={renderingRules.page_margin_left}
                  onChange={e => setRenderingRules({...renderingRules, page_margin_left: parseInt(e.target.value) || 0})}
                />
              </div>
              <div>
                <Label>Margine Destro (mm)</Label>
                <Input
                  type="number"
                  value={renderingRules.page_margin_right}
                  onChange={e => setRenderingRules({...renderingRules, page_margin_right: parseInt(e.target.value) || 0})}
                />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Opzioni Rendering</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <Label>Ripeti Header su ogni pagina</Label>
                <p className="text-sm text-gray-500">Mostra l'intestazione su tutte le pagine</p>
              </div>
              <Switch
                checked={renderingRules.repeat_header}
                onCheckedChange={v => setRenderingRules({...renderingRules, repeat_header: v})}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>Ripeti Footer su ogni pagina</Label>
                <p className="text-sm text-gray-500">Mostra il piè di pagina su tutte le pagine</p>
              </div>
              <Switch
                checked={renderingRules.repeat_footer}
                onCheckedChange={v => setRenderingRules({...renderingRules, repeat_footer: v})}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>Ripeti intestazione tabelle</Label>
                <p className="text-sm text-gray-500">Quando la tabella continua su più pagine</p>
              </div>
              <Switch
                checked={renderingRules.repeat_table_header}
                onCheckedChange={v => setRenderingRules({...renderingRules, repeat_table_header: v})}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>Firma solo su ultima pagina</Label>
                <p className="text-sm text-gray-500">Area firma visibile solo nell'ultima pagina</p>
              </div>
              <Switch
                checked={renderingRules.signature_last_page_only}
                onCheckedChange={v => setRenderingRules({...renderingRules, signature_last_page_only: v})}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>Blocchi legali dopo totali</Label>
                <p className="text-sm text-gray-500">Posiziona clausole dopo la sezione totali</p>
              </div>
              <Switch
                checked={renderingRules.legal_blocks_after_totals}
                onCheckedChange={v => setRenderingRules({...renderingRules, legal_blocks_after_totals: v})}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>Evita titoli a fine pagina</Label>
                <p className="text-sm text-gray-500">Previene titoli sezione orfani</p>
              </div>
              <Switch
                checked={renderingRules.avoid_section_title_at_page_bottom}
                onCheckedChange={v => setRenderingRules({...renderingRules, avoid_section_title_at_page_bottom: v})}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RenderingTab;
